import { FetchUserResponse } from '@digimap/types/api'
import apiFetch from './apiFetch'

export default async function fetchUser() {
  return await apiFetch<void, FetchUserResponse>('me')
}
